<template>
  <div class="container">
    <app-header :title="title"/>
    <van-search v-model="value" @click="$router.push('/search')" placeholder="请输入搜索关键词" />
    <!-- 分类 -->
    <div  style="overflow: hidden">
      <div class="tabs row">
        <div class="tab" v-text="item.name" v-for="(item,index) in tabList" :key="index" :class="[item.id == activeTag?'active':'']" @click="handleTag(item,index)"></div>
      </div>
    </div>
    <Category :cateList="twoChild" v-if="twoChild.length > 0"/>

    <!-- 推荐商品 -->
    <Goods :productList="productList"/>

  </div>
</template>

<script>
import Goods from './modules/Goods'
import Category from './modules/Category'
import { getShopCategoryList } from '@/api/category'
import { getShopProductList,getShopCategoryProdList} from '@/api/product'
export default {
  name: 'Index',
  components: {
    Goods,
    Category
  },
  data() {
    return {
      title : '集成电路',
      value: '',
      activeTag: 0,
      productList: [],
      tabList: [],
      twoChild: []
    }
  },
  watch:{
    $route(){
      //跳转到该页面后需要进行的操作
      if (this.$route.query.name != null && this.$route.query.name != undefined) {
         this.title = this.$route.query.name
      }
      this.activeTag = this.$route.query.activeTag
      //this.getTab()
      if (this.$route.query.from == 'homeTop') {
        this.getCateProduct(this.$route.query.id,true,0)
      } else if (this.$route.query.from == 'category') {
        this.tabList = JSON.parse(this.$route.query.categoryList)
        this.getCateProduct(this.$route.query.id,false,1)
      } else {
        this.getCateProduct(-1,false,1)
      }
    }
  },
  created() {
    if (this.$route.query.name != null && this.$route.query.name != undefined) {
       this.title = this.$route.query.name
    }
    this.activeTag = this.$route.query.activeTag
    //this.getTab()
    if (this.$route.query.from == 'homeTop') {
      this.getCateProduct(this.$route.query.id,true,0)
    } else if (this.$route.query.from == 'category') {
      this.tabList = JSON.parse(this.$route.query.categoryList)
      this.getCateProduct(this.$route.query.id,false,1)
    } else {
      this.getCateProduct(-1,false,1)
    }
  },
  methods: {
    getTab() {
      getShopCategoryList({ type: 0, pid: 0 }).then(res => {
        if (res.success) {
          this.tabList = res.data
          if (this.tabList) {
            this.activeTag = this.tabList[0].id
            this.getProduct(this.activeTag)
          }
        }
      })
    },
    getProduct(cid) {
      getShopProductList({ type: 0, parentId: cid }).then(res => {
        if (res.success) {
          this.productList = res.data
        }
      })
    },
    /**
     *
     * @param cid 上级菜单ID
     * @param bool 是否
     * @param type 是否有二级子菜单
     */
    getCateProduct(cid,bool,type) {
      getShopCategoryProdList({id: cid,type:type}).then(res => {
        if (res.success) {
          this.productList = res.data.productList
          if (cid == -1) {
            this.tabList = res.data.childList
            this.twoChild = res.data.childList[0].children
            this.activeTag = res.data.childList[0].id
          } else {
            if (type == 1) {
              this.twoChild = res.data.childList
            } else {
              this.twoChild = res.data.twoChildList
              this.tabList = res.data.childList
            }
            if (bool) {
              this.activeTag = res.data.childList[0].id
            } else {
              this.activeTag = cid
            }
          }
        }
      })
    },
    onNavigate(url) {
      this.$router.push({
        path: url
      })
    },
    handleTag(item,index) {
      this.activeTag = item.id
      this.getCateProduct(item.id,false,1)
    },
    gotoSearchProduct() {
      if (this.value == '') {
        return
      }
      this.$router.push({
        path: '/searchProduct',
        query: {
          name: this.value
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .van-nav-bar__left img {
    width: 25px;
    height: 25px;
  }
  .container{

    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      line-height: 44px;
      padding: 0 12px;
      overflow-x: scroll;
      -webkit-backface-visibility: hidden;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
      }
      .tab {
        height:25px;
        line-height: 25px;
        padding: 0 0.4rem;
        white-space: nowrap;
        font-size: 16px;
        font-weight:bold;
        cursor: pointer;
        &.active {
          color: #FE003B;
          border-bottom: 3px solid #FE003B;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/index.vue